import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { CategoryToAddonItemLinkContainerModel } from '../../../../../../models/aggregates/erp/add-ons-extended-warranty/category-to-add-on-item-link-container.model';





@Injectable({
  providedIn: 'root'
})
export class CategoryToAddonItemLinkService extends BaseApiTemplateService<CategoryToAddonItemLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'category-to-addon-item-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  Core2Config.FI_PREFIX + 'category-to-addon-item-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'category-to-addon-item-links/backoffice-ep';
    this.httpClient = http;
  }
}

